import axios from 'axios'

export interface Account {
  id: string
  email: string
  firstName: string
  lastName: string
  role: 'USER' | 'ADMIN'
  status: string
  createdAt: string
  updatedAt: string
}

export interface GetAccountsParams {
  page?: number
  limit?: number
  search?: string
  role?: 'USER' | 'ADMIN'
}

export interface GetAccountsResponse {
  accounts: Account[]
  pagination: {
    total: number
    page: number
    limit: number
    totalPages: number
  }
}

export const getAllAccounts = async (
  params?: GetAccountsParams
): Promise<GetAccountsResponse> => {
  const response = await axios.get('admin-management/accounts', {
    params,
    withCredentials: true
  })
  return response.data
}

export const addAdmin = async (accountId: string): Promise<Account> => {
  const response = await axios.post(
    'admin-management/add-admin',
    { accountId },
    {
      withCredentials: true
    }
  )
  return response.data.data
}

export const removeAdmin = async (accountId: string): Promise<Account> => {
  const response = await axios.post(
    'admin-management/remove-admin',
    { accountId },
    {
      withCredentials: true
    }
  )
  return response.data.data
}

export const deleteAccount = async (
  accountId: string
): Promise<{ id: string; email: string }> => {
  const response = await axios.delete(
    `admin-management/accounts/${accountId}`,
    {
      withCredentials: true
    }
  )
  return response.data.data
}
